import React from "react"
import styled from "styled-components"

import { MtDriveFile } from "server/models"
import { getFile } from "client/store"

interface LogoImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    size?: number
    borderRadius?: number
    offsetBottom?: boolean
}

const LogoImg = styled.img<LogoImgProps>`
    height: ${(props) => (props.height || (props.size ? `${props.size}px` : "unset"))};
    width: ${(props) => (props.width || (props.size ? `${props.size}px` : "100%"))};
    border-radius: ${(props) => (props.borderRadius ? `${props.borderRadius}px` : "0")};
    margin-bottom: ${(props) => (props.offsetBottom ? "8px" : 0)};
    object-fit: cover;
    object-position: center;
    vertical-align: middle;
    background: ghostwhite;
    color: black;
`

export interface LogoProps extends LogoImgProps {
    logo: MtDriveFile | string
    table?: boolean
}

export const Logo = ({
    logo,
    size,
    borderRadius,
    table,
    ...other
}: LogoProps) => {
    let src
    const file = logo as MtDriveFile
    if (!file) return null

    if (file.storage) {
        const version = file.versions && file.versions[0]
        src = file && version ? getFile(file, version).preview : null
    } else {
        src = logo as string
    }

    if (table) {
        return (
            <LogoImg
                src={src}
                size={40}
                borderRadius={8}
                {...other}
            />
        )
    }
    return (
        <LogoImg
            src={src}
            size={size}
            borderRadius={borderRadius}
            {...other}
        />
    )
}
